import type { GetDashboardAuditByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetDashboardAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDashboardAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDashboardAuditByIdArgs = {
  id: string;
};

export const useGetDashboardAuditById = createQueryHook<
  UseGetDashboardAuditByIdArgs,
  GetDashboardAuditByIdResponseRow[],
  GetDashboardAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getDashboardAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ dashboard_audit: data }),
  graphqlDocument: GetDashboardAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
